var multislider = document.querySelectorAll(".section-multislide .pics > div");

console.log("multislider", multislider);

window.addEventListener("load", function () {
	if (multislider) {
		// stagger slide in
		multislider.forEach((slide, i) => {
			setTimeout(() => {
				slide.classList.add("show");
			}, i * 200);
		});
		multislider.forEach((slide, i) => {});
	}
});

function resizeVideo(){
  jQuery('.section-video').each(function(){
    var container = jQuery(this).find('.iframe');
    var media = container.find('iframe, video');
    var width = container.width();
    var height = container.height();
    var newHeight = width * 0.5625;
    if (newHeight < height) {
      // Fit by height
      newHeight = height;
      width = height / 0.5625;
    }
    media.css({
      width: width + 'px',
      height: newHeight + 'px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    });

  });  
}

jQuery(document).ready(function($) {
  // Resize video on load
  resizeVideo();

  // Resize video on window resize
  $(window).resize(function() {
    resizeVideo();
  });

  // Resize video on orientation change
  window.addEventListener("orientationchange", function() {
    resizeVideo();
  });
});